import { postMessage } from '@dcloudio/uni-webview-js'
const resolveObj = {}
const rejectObj = {}

// window.sendMessage = function sendMessage({ action, data }) {
//   console.log('receiveAppMessage:' + action + ':' + JSON.stringify(data))
//   if (resolveObj[action]) {
//     resolveObj[action].call(null, data)
//   } else {
//     return data
//   }
// }

window.addEventListener('custom-event', res => {
  console.log('🌈 -- window.on --custom-event-- res:', res.detail)
  const { action, data, type } = res.detail
  if (type === 'resolve') {
    if (resolveObj[action]) {
      resolveObj[action].call(null, data ? data.data || data : data)
    }
    return
  }
  if (type === 'reject') {
    if (rejectObj[action]) {
      rejectObj[action].call(null, data ? data.data || data : data)
    }
  }
})

// 参数请参考文档 https://uniapp.dcloud.net.cn/api/
export default {
  /**
   * 通知app更新用户信息
   */
  refreshUserInfo() {
    return new Promise((resolve, reject) => {
      resolveObj.refreshUserInfo = resolve
      rejectObj.refreshUserInfo = reject
      postMessage({
        data: {
          action: 'refreshUserInfo',
        },
      })
    })
  },
  /**
   *
   *  @returns { "dcb": true, 是否在多彩宝客户端中。 "ios": true, 是否在 iOS 设备中。 "android": false, 是否在 Android 设备中。 "wechat": false, 是否在微信中。 "alipay": false 是否在支付宝中。
      }
   */
  // getEnv() {
  //   return new Promise((resolve, reject) => {
  //     resolveObj.getEnv = resolve
  //     rejectObj.getEnv = reject
  //     postMessage({
  //       data: {
  //         action: 'getEnv',
  //       },
  //     })
  //   })
  // },
  getEnv() {
    const env = {
      dcb: false, // 多彩宝
      miniprogram: false, // 微信小程序
      wechat: false, // 微信公众号
      ios: true,
      android: false,
      alipay: false,
      love: false, // 爱情计算器app
      // gsy: gsy.getEnvSync().gsy,
    }
    const ua = window.navigator.userAgent.toLowerCase()
    if (ua.includes('dcb-app')) {
      env.dcb = true
    } else if (ua.includes('love-calculator')) {
      env.love = true
    } else if (ua.includes('micromessenger')) {
      if (ua.includes('miniprogram')) {
        env.miniprogram = true
      } else {
        env.wechat = true
      }
    }

    return env
  },

  /**
   *  @returns { "appId":"__UNI__90786EE", "appName":"爱情计算器", "appVersion":"13.7.9", "appVersionCode":130709, "appWgtVersion":"1.0.0", "appLanguage":"zh-Hans", "enableDebug":false, "language":"zh-CN", "SDKVersion":"", "theme":"light", "version":"1.9.9.81745" }
   */
  getAppInfo() {
    return new Promise((resolve, reject) => {
      resolveObj.getAppInfo = resolve
      rejectObj.getAppInfo = reject
      postMessage({
        data: {
          action: 'getAppInfo',
        },
      })
    })
  },
  /**
   * https://uniapp.dcloud.net.cn/api/router.html#navigateback
   */
  navigateBack(options) {
    postMessage({
      data: {
        action: 'navigateBack',
        options,
      },
    })
  },
  /**
   *
   * @param {url} options 支持http:// https://  lv://pages/index/index如果需要跳转到webview界面并打开h5，请使用lv://pages/webview/index?url=encodeURIComponent(h5链接)
   */
  navigateTo(options) {
    postMessage({
      data: {
        action: 'navigateTo',
        options,
      },
    })
  },
  /**
   *
   * @param {returnResult} options  // 是否需要返回扫码结果
   * @returns {result: String, resultType: String} // 扫码结果returnResult时返回为undefined
   */
  scanCode(options) {
    return new Promise((resolve, reject) => {
      resolveObj.scanCode = resolve
      rejectObj.scanCode = reject
      postMessage({
        data: {
          action: 'scanCode',
          options,
        },
      })
    })
  },
  /**
   * @param {phoneNumber} options  // 号码
   */
  makePhoneCall(options) {
    postMessage({
      data: {
        action: 'makePhoneCall',
        options,
      },
    })
  },
  /**
   *
   * @returns Number 状态栏高度
   */
  getStatusBarHeight() {
    return new Promise((resolve, reject) => {
      resolveObj.getStatusBarHeight = resolve
      rejectObj.getStatusBarHeight = reject
      postMessage({
        data: {
          action: 'getStatusBarHeight',
        },
      })
    })
  },
  /**
   * 参数请参考文档 https://uniapp.dcloud.net.cn/api/plugins/share.html#share
   * @returns
   */
  share(options) {
    return new Promise((resolve, reject) => {
      resolveObj.share = resolve
      rejectObj.share = reject
      postMessage({
        data: {
          action: 'share',
          options,
        },
      })
    })
  },
  /**
   * 参数请参考文档 https://uniapp.dcloud.net.cn/api/plugins/share.html#share
   * @returns
   */
  shareImage(options) {
    return new Promise((resolve, reject) => {
      resolveObj.shareImage = resolve
      rejectObj.shareImage = reject
      postMessage({
        data: {
          action: 'shareImage',
          options,
        },
      })
    })
  },
  /**
   * 参数请参考文档 https://uniapp.dcloud.net.cn/api/media/image.html#saveimagetophotosalbum
   * @returns
   */
  saveImageToPhotosAlbum(options) {
    return new Promise((resolve, reject) => {
      resolveObj.saveImageToPhotosAlbum = resolve
      rejectObj.saveImageToPhotosAlbum = reject
      postMessage({
        data: {
          action: 'saveImageToPhotosAlbum',
          options,
        },
      })
    })
  },
  /**
   * 参数请参考文档 https://uniapp.dcloud.net.cn/api/plugins/payment.html#requestpayment
   * @returns
   */
  requestPayment(options) {
    return new Promise((resolve, reject) => {
      resolveObj.requestPayment = resolve
      rejectObj.requestPayment = reject
      postMessage({
        data: {
          action: 'requestPayment',
          options,
        },
      })
    })
  },
  /**
   *
   * @param  options 直接诶传版本号例如2.1.3
   * @returns
   * {
   *   "greater": true, 是否大于要比较的版本号。
   *   "less": false,是否小于要比较的版本号。
   *  "equal": false,是否等于要比较的版本号。
   *  "greaterOrEqual": true,是否大于或等于要比较的版本号
   *  "lessOrEqual": false是否小于或等于要比较的版本号
   * }
   */
  compareAppVersion(options) {
    return new Promise((resolve, reject) => {
      resolveObj.compareAppVersion = resolve
      rejectObj.compareAppVersion = reject
      postMessage({
        data: {
          action: 'compareAppVersion',
          options,
        },
      })
    })
  },
  /**
   * 实名认证
   * @returns
   */
  requestRealNameAuthentication() {
    return new Promise((resolve, reject) => {
      resolveObj.requestRealNameAuthentication = resolve
      rejectObj.requestRealNameAuthentication = reject
      return postMessage({
        data: {
          action: 'requestRealNameAuthentication',
        },
      })
    })
  },
  /**
   * 活体认证
   * @returns
   */
  requestFaceAuthentication() {
    return new Promise((resolve, reject) => {
      resolveObj.requestFaceAuthentication = resolve
      rejectObj.requestFaceAuthentication = reject
      return postMessage({
        data: {
          action: 'requestFaceAuthentication',
        },
      })
    })
  },
  /**
   * 代理认证
   * @returns
   */
  takeFaceAuthenticationProxy(options) {
    return new Promise((resolve, reject) => {
      resolveObj.takeFaceAuthenticationProxy = resolve
      rejectObj.takeFaceAuthenticationProxy = reject
      return postMessage({
        data: {
          action: 'takeFaceAuthenticationProxy',
          options,
        },
      })
    })
  },
  /**
   * 设置剪切板 setClipboardData('123')
   * @returns
   */
  setClipboardData(options) {
    postMessage({
      data: {
        action: 'setClipboardData',
        options,
      },
    })
  },
  /**
   * 可取值： "#ffffff"：深色前景色样式（即状态栏前景文字为黑色），此时background建议设置为浅颜色； "#000000"：浅色前景色样式（即状态栏前景文字为白色），此时background建设设置为深颜色；
   * @param {frontColor} options
   * setStatusBarColor('#ffffff')
   */
  setStatusBarColor(options) {
    postMessage({
      data: {
        action: 'setStatusBarColor',
        options,
      },
    })
  },
  /**
   *
   * @param {delta } options 关闭当前窗口并返回的步数 ，默认为1
   * @returns
   */
  closeWindow(options) {
    return postMessage({
      data: {
        action: 'closeWindow',
        options,
      },
    })
  },
  /**
   * 打开第三方地图
   */
  openThirdMap(options) {
    postMessage({
      data: {
        action: 'openThirdMap',
        options,
      },
    })
  },
}
